import { Fragment, useState } from "react";
import { Modal, Button, Spin, Result } from "antd";
import { TitleHeader, Searcher, TableAntd } from "../../components/commons";
import { Redirect } from "react-router-dom";
import { useQuery } from "react-query";
import { useAuth } from "../../utils/useAuth";
import { getAll } from "../../api/user";
import { createColumns } from "./formatTable";
import AddUser from "./components/AddUser";
import EditUser from "./components/EditUser";
import DeleteUser from "./components/DeleteUser";

function Users() {
  const { isAdmin } = useAuth();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [filterTable, setFilterTable] = useState(null);
  const [page, setPage] = useState(1);
  const [modalTitle, setModalTitle] = useState("");
  const { data, isError, error, isLoading } = useQuery("users", getAll);

  // ------ Show modal add user -----------
  const showAddModal = () => {
    setIsModalVisible(true);
    setModalTitle("Agregar usuario");
    setModalContent(<AddUser closeModal={closeModal} />);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  // ------ Show modal edit user -----------
  const showEditModal = (user) => {
    setIsModalVisible(true);
    setModalTitle("Editar usuario");
    setModalContent(
      <EditUser user={user} closeModal={closeModal} setModalContent={setModalContent} />
    );
  };

  // ------ Show modal delete user -----------
  const showDeleteModal = (user) => {
    setIsModalVisible(true);
    setModalTitle("Eliminar usuario");
    setModalContent(<DeleteUser user={user} closeModal={closeModal} />);
  };

  if (!isAdmin) return <Redirect to="/app" />;

  if (isLoading) {
    return <Spin tip="Cargando" className="w-full py-60" />;
  }

  if (isError) {
    return (
      <Result
        status="500"
        title="Algo salió mal"
        subTitle={error.message}
        extra={
          <Button onClick={() => window.location.reload()} type="primary">
            Recargar
          </Button>
        }
      />
    );
  }

  // ------ Formato para que se muestre en la tabla ------
  const columnsToTable = createColumns(page, showEditModal, showDeleteModal);

  // ------ Search filter ------
  /**
   * search
   * @param {String} value
   * Busca por cualquier valor de la columna
   * fuentes:
   * https://codesandbox.io/s/basic-usage-ant-design-demo-2swep?file=/index.js
   * https://github.com/ant-design/ant-design/issues/22969#issuecomment-611738230
   */
  const search = (value) => {
    const tempFilterTable = data.payload.filter((o) =>
      Object.keys(o).some((k) => String(o[k]).toLowerCase().includes(value.toLowerCase()))
    );

    setFilterTable(tempFilterTable);
  };

  return (
    <Fragment>
      <TitleHeader
        title="Usuarios"
        buttonTitle="Nuevo usuario"
        onButtonTitleHeaderClick={showAddModal}
      />

      <Searcher onSearch={search} placeholder="Busca algún usuario" />

      <TableAntd
        columns={columnsToTable}
        dataSource={filterTable == null ? data.payload : filterTable}
        setPage={setPage}
      />

      <Modal
        title={modalTitle}
        visible={isModalVisible}
        footer={null}
        onCancel={closeModal}
        destroyOnClose
        maskClosable={false}
      >
        {modalContent}
      </Modal>
    </Fragment>
  );
}

export default Users;
